import {Component, OnInit} from '@angular/core';
import {UploadService} from '../../services/upload.service';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['../../app.component.scss', './upload.component.scss']
})
export class UploadComponent implements OnInit {
  previewUrl: string | ArrayBuffer;
  selectedFile: File;
  isBusy = false;
  downloadUrl: string;

  constructor(public uploadService: UploadService) {
  }

  ngOnInit(): void {
  }

  uploadVideo(): void {
    if (!this.isBusy && this.selectedFile) {
      const fd: FormData = new FormData();
      fd.append('file', this.selectedFile);
      this.isBusy = true;
      this.uploadService.uploadMultiMedia(fd, (url: string) => {
        this.downloadUrl = url;
        this.isBusy = false;
      }, () => {
        this.isBusy = false;
      });
    }
  }

  download(): void {
    window.open(this.downloadUrl);
  }

  onSelectFile(event): void {
    const file = event.target.files && event.target.files[0];
    if (file) {
      this.selectedFile = file;
      const reader = new FileReader();
      reader.readAsDataURL(file);

      if (file.type.indexOf('video') > -1) {
        reader.onload = (event2) => {
          this.previewUrl = event2.target.result;
        };
      }
    }
  }

}
